import qs from "qs";
import { isNonNullable, isNullable } from "../type-guards";
export const GoogleMapsUtils = {
    directions(spots, noToll) {
        const spotQueries = spots
            .map(GoogleMapsUtils.spotQuery)
            .filter(isNonNullable);
        const origin = spotQueries.at(0);
        const destination = spotQueries.at(-1);
        const waypoints = spotQueries.slice(1, spotQueries.length - 1);
        if (isNullable(origin) || isNullable(destination)) {
            return undefined;
        }
        const queryObject = {
            ...GoogleMapsUtils.baseQuery,
            travelmode: "driving",
            origin,
            destination,
            waypoints: waypoints.length > 1 ? waypoints.join("|") : undefined,
            avoid: noToll ? "highways,tolls,ferries" : undefined,
        };
        return `${GoogleMapsUtils.url}/dir/?${qs.stringify(queryObject)}`;
    },
    spot(spot) {
        const spotQuery = GoogleMapsUtils.spotQuery(spot);
        if (isNullable(spotQuery)) {
            return undefined;
        }
        const query = {
            output: "embed",
            hl: "ja",
            z: 13,
            disableDefaultUI: "true",
            q: spotQuery,
        };
        return `${GoogleMapsUtils.url}?${qs.stringify(query)}`;
    },
    spotQuery(spot) {
        if (isNullable(spot)) {
            return undefined;
        }
        const addressList = [spot.prefecture, spot.address1, spot.address2].filter(isNonNullable);
        const address = addressList.length > 0 ? addressList.join(" ") : undefined;
        const queryList = [address, spot.spotName].filter(isNonNullable);
        return queryList.length > 0 ? queryList.join("+") : undefined;
    },
    url: "https://maps.google.co.jp/maps",
    baseQuery: {
        api: 1,
        hl: "ja",
    },
};
//# sourceMappingURL=google-maps-utils.js.map